
/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import speedometerPriceVsSpeed from '../speedometers/Speedometer_PriceVSpeed_NoLoop_03_Lottie.json';

const SpeedometerPriceVsSpeed = (props) => {

    return (
        <Lottie animationData={JSON.parse(JSON.stringify(speedometerPriceVsSpeed))} {...props}/>
    );
}

export default SpeedometerPriceVsSpeed;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/speedometers/speedometerPriceVsSpeed.jsx